/* es-form 2026-09: invio all'OS con validazione nativa, honeypot, stato chiaro. */
(function(){
  document.querySelectorAll('form[data-esf]').forEach(function(f){
    if(f.dataset.esfOn) return; f.dataset.esfOn='1';
    var msg=f.querySelector('.esf__msg'), btn=f.querySelector('.esf__send'), lbl=btn.textContent;
    f.addEventListener('change',function(e){ if(e.target.name==='reparto') f.classList.toggle('is-b2b',e.target.value==='b2b'); });
    f.addEventListener('submit',function(e){
      e.preventDefault();
      if(!f.checkValidity()){ f.reportValidity(); return; }
      var campi={}; new FormData(f).forEach(function(v,k){ if(k!=='trappola'&&k!=='consenso') campi[k]=String(v).trim(); });
      var body={modulo:f.dataset.modulo,campi:campi,lingua:f.dataset.lang,pagina:location.pathname,trappola:f.trappola.value};
      btn.disabled=true; btn.textContent=f.dataset.sending; msg.hidden=true; msg.className='esf__msg';
      fetch(f.dataset.endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)})
        .then(function(r){ return r.json().then(function(j){ return {ok:r.ok,j:j}; }); })
        .then(function(x){
          msg.hidden=false;
          if(x.ok){ msg.textContent=f.dataset.ok; f.classList.add('is-done'); try{(window.dataLayer=window.dataLayer||[]).push({event:'form_submit',form:f.dataset.modulo,reparto:campi.reparto||''});}catch(err){} }
          else { msg.className='esf__msg is-err'; msg.textContent=(x.j&&x.j.errore)||f.dataset.err; btn.disabled=false; btn.textContent=lbl; }
        })
        .catch(function(){ msg.hidden=false; msg.className='esf__msg is-err'; msg.textContent=f.dataset.err; btn.disabled=false; btn.textContent=lbl; });
    });
  });
})();
